import { Button, Checkbox, Form, Input, Space, Tooltip } from 'antd';
import { LoginOutlined } from '@ant-design/icons';
import i18next from "i18next";
import { useDispatch, useSelector } from 'react-redux';
import { login, logout, user_state } from '../../../features/user/userSlice';
import { SecurityService } from '../../../service/securityService';


const LoginComponent = (props) => {

    const dispatch = useDispatch();
    const userstate = useSelector(user_state);

    const loginExpiration = 60 * 1000 * 60 * 24 * 30 // Expira en 30 días
    let values = { "username": null, "password": null, "remember": false };

    let loginComponentValues = localStorage.getItem("sgvmap40_loginComponentValues");
    if (loginComponentValues) loginComponentValues = JSON.parse(loginComponentValues);

    if (loginComponentValues && loginComponentValues.expiry > Date.now()) {
        values = loginComponentValues.value;
    }

    const handleLogin = (value) => {
        dispatch(login(value))
    };

    const handleLogout = () => {
        dispatch(logout())
    };


    const onFinish = (values) => {
        //console.log('Finish:', values);
        if (values.remember) {
            // `item` is an object which contains the original value
            // as well as the time when it's supposed to expire
            const item = {
                value: values,
                expiry: Date.now() + loginExpiration,
            }
            localStorage.setItem("sgvmap40_loginComponentValues", JSON.stringify(item));
        }
        else {
            localStorage.removeItem("sgvmap40_loginComponentValues");
        }

        SecurityService.authenticate(values.username, values.password).then((data) => {
            let token = data.token;
            SecurityService.getUser(token).then((data) => {
                let userFeature = {};
                userFeature.username = data.username
                userFeature.authorities = data.roles;
                userFeature.token = token;
                handleLogin(userFeature);
                console.log("data", data);
            })
            
            //handleLogin(data);

        })/*.catch(err => {
            //console.log(err.response)
            err.response.json().then(res => {
                //console.log(res);
            });
        })*/
    };
    const onFinishFailed = (errorInfo) => {
        //console.log('Failed:', errorInfo);
    };

    return (<>
        {userstate.logged && <LogoutForm userstate={userstate} handleLogout={handleLogout}></LogoutForm>}
        {!userstate.logged && <LoginForm values={values} onFinish={onFinish} onFinishFailed={onFinishFailed}></LoginForm>}
    </>
    )
}
export default LoginComponent;


const LogoutForm = ({ userstate, handleLogout }) => {
    return (
        <Space>
            {i18next.t('common.tools.login.logged_as') + ' '}<b>{userstate.username}</b>
            <Tooltip title={i18next.t('common.tools.login.logout')}>
                <Button type="primary" icon={<LoginOutlined />} onClick={(e) => handleLogout()} />
            </Tooltip>
        </Space>


    )

}

const LoginForm = ({ values, onFinish, onFinishFailed }) => {
    return (
        <Form
            name="basic"
            layout="vertical"
            initialValues={values}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
        >
            <Form.Item
                label={i18next.t('common.tools.login.username')}
                name="username"
                rules={[
                    {
                        required: true,
                        message: i18next.t('common.tools.login.username_required'),
                    },
                ]}
            >
                <Input />
            </Form.Item>

            <Form.Item
                label={i18next.t('common.tools.login.password')}
                name="password"
                value={values.password}
                rules={[
                    {
                        required: true,
                        message: i18next.t('common.tools.login.password_required'),
                    },
                ]}
            >
                <Input.Password />
            </Form.Item>

            <Form.Item
                name="remember"
                valuePropName="checked"
                value={values.remember}
                wrapperCol={{
                    offset: 8,
                    span: 16,
                }}
            >
                <Checkbox>{i18next.t('common.tools.login.rememberme')}</Checkbox>
            </Form.Item>

            <Form.Item
                wrapperCol={{
                    offset: 8,
                    span: 16,
                }}
            >
                <Button type="primary" htmlType="submit">
                    {i18next.t('common.tools.login.initsession')}
                </Button>
            </Form.Item>
        </Form>
    )
}